module.exports = __webpack_public_path__ + "media/images/top/package/package-image2-cc36990eda8a311f2438db05fb6303f7.png";